'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var viewBox = function viewBox(direction) {
  switch (direction) {
    case 'left':
    case 'right':
      return '0 0 7 13';
    case 'up':
    case 'down':
    default:
      return '0 0 13 7';
  }
};

var points = function points(direction) {
  switch (direction) {
    case 'left':
      return '6 1, 1 6.5, 6 12';
    case 'right':
      return '1 1, 6 6.5, 1 12';
    case 'up':
      return '1 6, 6.5 1, 12 6';
    case 'down':
    default:
      return '1 1, 6.5 6, 12 1';
  }
};

var Chevron = function Chevron(_ref) {
  var direction = _ref.direction;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-chevron quiver-chevron--' + direction },
    _react2.default.createElement(
      'svg',
      {
        viewBox: viewBox(direction),
        preserveAspectRatio: 'xMinYMin meet'
      },
      _react2.default.createElement('polyline', {
        points: points(direction),
        fill: 'none',
        strokeLinejoin: 'round'
      })
    )
  );
};

Chevron.propTypes = {
  direction: _propTypes2.default.string
};

Chevron.defaultProps = {
  direction: 'down'
};

exports.default = Chevron;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Chevron/Chevron.js
// module id = 275
// module chunks = 0